module.exports = __webpack_public_path__ + "img/personalization.e221d8f3.svg";